export default "__VITE_ASSET__xE4ZHzOi__"